import { GridColDef, GridFilterInputValue, GridFilterItem, GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import moment from 'moment';

export const isEmpty = (v: unknown) => v === '' || v === null || v === undefined;

export const isValidDateFormat = (v: unknown) => {
  if (typeof v !== 'string') return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
  const d = new Date(v);
  return !Number.isNaN(d.getTime());
};

export const stringContainsOnly: GridColDef['filterOperators'] = [
  {
    label: 'Contains',
    value: 'contains',
    getApplyFilterFn: () => null,
    InputComponent: GridFilterInputValue,
  },
];

export const isNonEmpty = (v: any) => {
  if (v === 0 || v === false) return true;
  if (v === null || v === undefined) return false;
  return String(v).trim() !== '';
};

export const formatDate =
    (date?: string | Date) => date ? moment(date).format('MM/DD/YYYY') : '-';

export function toIsoDateTime(value: unknown): string | null {
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value.toISOString();
  }

  if (typeof value === 'string') {
    const m = moment(value, [moment.ISO_8601, 'MM/DD/YYYY', 'M/D/YYYY'], true);
    return m.isValid() ? m.toDate().toISOString() : null;
  }

  return null;
}

export const normalizeFilterModel = (m: GridFilterModel): GridFilterModel => ({
  ...m,
  items: (m.items ?? []).filter((it: GridFilterItem) => {
    return !!it.columnField && !!it.operatorValue && isNonEmpty(it.value);
  }),
});

export const sameModel = (a: GridFilterModel, b: GridFilterModel) =>
  JSON.stringify(a) === JSON.stringify(b);

export type DataGridQueryParams = {
  page: number;
  pageSize: number;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
};

export function buildDataGridParams({
  page,
  pageSize,
  sortModel,
  filterModel,
}: DataGridQueryParams): Record<string, any> {
  const params: Record<string, any> = {
    limit: pageSize,
    offset: page * pageSize,
  };

  const sort = sortModel?.[0];
  if (sort?.field && sort?.sort) {
    params.ordering = sort.sort === 'asc' ? sort.field : `-${sort.field}`;
  }

  if (filterModel?.items?.length) {
    filterModel.items.forEach((item) => {
      if (item.value === undefined || item.value === null || String(item.value).trim() === '') return;
      if (!item.columnField) return;

      params[item.columnField] = item.value;
    });
  }

  return params;
}